import React from 'react'
import '../assets/css/AdHocMultipleAddsModal.css';
import TextArea from '../DMGComponents/TextArea'
import { validateEmail } from '../utils/helperFunctions';

class EmailAddressesTextArea extends React.Component {
    constructor(props) {
        super(props);
        this._textArea = React.createRef();
        this.state = {
            validEmails: [],
            invalidEmails: [],
            validationErrorMsg: '',
        }
    }

    handleTextAreaChanged = (textArea) => {
        this.setState({
            validEmails: [],
            invalidEmails: [],
            validationErrorMsg: '',
        });
        let taVal = textArea.target.value;
        if (taVal && taVal.length > 0) {
            let validEmails = [];
            let invalidEmails = [];
            let lines = taVal.split('\n');
            let cleanedLines = [];
            for (let i = 0; i < lines.length; i++) {
                let currLine = lines[i].trim();
                if (currLine.length === 0) {
                    continue;
                }
                if (currLine.indexOf(";") > -1) {
                    let splittedLine = currLine.split(";");
                    for (var j = 0; j < splittedLine.length; j++) {
                        if (splittedLine[j].length === 0) {
                            continue;
                        }
                        if (!cleanedLines.includes(splittedLine[j])) {
                            cleanedLines.push(splittedLine[j]);
                        }
                    }
                }
                else {
                    if (!cleanedLines.includes(currLine)) {
                        cleanedLines.push(currLine);
                    }
                }
            }
            for (let i = 0; i < cleanedLines.length; i++) {
                let currLine = cleanedLines[i].trim();
                if (!validateEmail(currLine)) {
                    invalidEmails.push(currLine)
                }
                else {
                    validEmails.push(currLine)
                }
            }
            let valMsg = '';
            if (invalidEmails.length > 0) {
                valMsg = 'Following emails are invalid: ';
                for (let i = 0; i < invalidEmails.length; i++) {
                    valMsg += invalidEmails[i] + ", "
                }
                valMsg = valMsg.slice(0, -2);
            }
            this.setState({
                invalidEmails: invalidEmails,
                validEmails: validEmails,
                validationErrorMsg: valMsg
            });
            if (this.props.updateValidEmails) {
                this.props.updateValidEmails(validEmails);
            }
            if (this.props.updateInvalidEmails) {
                this.props.updateInvalidEmails(invalidEmails.length > 0);
            }
        }
    }

    handleClose = () => {
        this.setState({
            validEmails: [],
            invalidEmails: [],
            validationErrorMsg: '',
        }, () => {
            this._textArea.current.clearTextArea();
        });
    }

    render() {
        return (
            <React.Fragment>
                <label>Enter multiple email addresses in the field below, one per line or separated by semicolon.</label>
                {this.state.validationErrorMsg.length > 0 &&
                    <label style={{ color: "#F50506" }}>{this.state.validationErrorMsg}</label>
                }
                <TextArea dontShowValidationStatus={true} label="Email addresses" onChange={this.handleTextAreaChanged} ref={this._textArea} />
            </React.Fragment>
        );
    }
};

export default EmailAddressesTextArea;